
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogues/[slugOrCatalogueId]",
      function () {
        return require("private-next-pages/catalogues/[slugOrCatalogueId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalogues/[slugOrCatalogueId]"])
      });
    }
  